import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getWageringTemplatePaginationStart } from '../../../../store/redux-slices/bonus'
import useDidMountEffect from '../../../../utils/useDidMountEffect'

const useWageringTemplate = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { loading, wageringTemplates } = useSelector((state) => state.bonus)
  const [selectedClient, setSelectedClient] = useState('')
  const [selectedPortal, setSelectedPortal] = useState('')
  const [limit, setLimit] = useState(15)
  const [pageNo, setPageNo] = useState(1)
  const [search, setSearch] = useState('')
  const isInitialRender = useDidMountEffect()

  const totalPages = Math.ceil(wageringTemplates?.count / limit)

  const fetchDetails = () => {
    dispatch(getWageringTemplatePaginationStart({
      isTenant: false,
      adminId: selectedClient,
      pageNo,
      search,
      limit
    }))
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (pageNo === 1) {
          fetchDetails()
        } else {
          setPageNo(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  useEffect(() => {
    setPageNo(1)
    fetchDetails()
  }, [selectedClient, limit])

  useEffect(() => {
    !isInitialRender && fetchDetails()
  }, [pageNo])

  return {
    loading,
    wageringTemplates,
    setSelectedClient,
    setSelectedPortal,
    selectedClient,
    selectedPortal,
    navigate,
    setLimit,
    setPageNo,
    setSearch,
    totalPages,
    limit,
    search,
    pageNo
  }
}

export default useWageringTemplate
